module.exports = {
  "我们为您提供了AI赚币、贷款、新币申购的功能":"เรามอบฟังก์ชันการรับสกุลเงิน AI สินเชื่อ และการสมัครสมาชิกสกุลเงินใหม่ให้กับคุณ",
  "AI赚币介绍":"รู้เบื้องต้นเกี่ยวกับกองทุน AI",
  "账户":"บัญชี",
  "盈亏":"กำไรและขาดทุน",
  "平仓时间":"เวลาปิด",
  "止盈止损":"ขายทำกำไรและหยุดการขาดทุน",
  "止盈":"ขายทำกำไร",
  "止损":"หยุดการสูญเสีย",
  "订单详情":"รายละเอียดการสั่งซื้อ",
  "取消":"ยกเลิก",
  "订单时间":"เวลาสั่งซื้อ",
  "搜索币种":"ค้นหาสกุลเงิน",
  "选择币种":"เลือกสกุลเงิน",
  "请输入手数":"กรุณากรอกจำนวนล็อต",
  "自选":"ไม่จำเป็น",
  "兑换":"แลกเปลี่ยน",
  "金额":"จำนวน",
  "得到":"รับ",
  "兑换手续费为":"ค่าธรรมเนียมการแลกเปลี่ยนคือ",
  "立即发送":"ส่งทันที",
  "申请时间":"เวลาสมัคร",
  "接收数量":"รับปริมาณ",
  "手续费":"ค่าธรรมเนียมการจัดการ",
  "充值":"เติม",
  "提现":"ถอน",
  "合约交易":"การซื้อขายตามสัญญา",
  "看涨":"รั้น",
  "看跌":"งุ่มง่าม",
  "请输入数量":"กรุณากรอกจำนวน",
  "买入":"ซื้อ",
  "收益":"รายได้",
  "杠杆":"คันโยก",
  "限价":"ขีด จำกัด ราคา",
  "市价":"ราคาตลาด",
  "卖出":"ขาย",
  "请输入价格":"กรุณากรอกราคา",
  "开仓成功":"เปิดตำแหน่งสำเร็จแล้ว",
  "交易账户":"บัญชีธุรกรรม",
  "交易币种":"สกุลเงินของธุรกรรม",
  "交易方向":"ทิศทางการซื้อขาย",
  "交易数量":"จำนวนธุรกรรม",
  "开仓价格":"ราคาเปิด",
  "保证金":"ระยะขอบ",
  "确认":"ยืนยัน",
  "持仓":"ตำแหน่ง",
  "当前委托":"คำสั่งซื้อปัจจุบัน",
  "历史记录":"บันทึกประวัติศาสตร์",
  "买涨":"ซื้อ",
  "买跌":"ซื้อหรือขาย",
  "撤单":"ยกเลิกคำสั่งซื้อ",
  "当前价格":"ราคาปัจจุบัน",
  "平仓":"ปิดตำแหน่ง",
  "总量":"จำนวนเงินทั้งหมด",
  "已完成":"สมบูรณ์",
  "福利专区":"พื้นที่สวัสดิการ",
  "请时刻关注福利活动，我们将不定期发布":"โปรดใส่ใจกับกิจกรรมด้านสวัสดิการอยู่เสมอเราจะเผยแพร่เป็นครั้งคราว",
  "发行日期":"วันที่ออก",
  "上市日期":"วันที่ลงรายการ",
  "请关注":"กรุณาให้ความสนใจ",
  "公告发布":"ประกาศเปิดตัว",
  "实际到账":"มาถึงจริง",
  "期权交易":"การซื้อขายตัวเลือก",
  "首页":"หน้าแรก",
  "提示":"คำใบ้",
  "请用钱包APP访问":"โปรดใช้แอปกระเป๋าสตางค์เพื่อเข้าถึง",
  "矿池赚币":"การขุดพูลได้รับเหรียญ",
  "快捷买币":"ซื้อเหรียญอย่างรวดเร็ว",
  "更多币种，快捷买币":"สกุลเงินมากขึ้น ซื้อเหรียญได้อย่างรวดเร็ว",
  "去购买":"ไปซื้อ",
  "公告":"ประกาศ",
  "P2P交易":"การซื้อขาย P2P",
  "P2P市场":"ตลาดพีทูพี",
  "链接加密未来":"เชื่อมโยงกับอนาคตของการเข้ารหัสลับ",
  "开始交易":"เริ่มต้นการซื้อขาย",
  "交易产品":"ซื้อขายสินค้า",
  "最低手续费":"ค่าธรรมเนียมการจัดการขั้นต่ำ",
  "合作单位":"บริษัท",
  "交易品种":"ซื้อขายพันธุ์",
  "更多":"มากกว่า",
  "交易品种市场趋势":"แนวโน้มตลาดการซื้อขายสินค้า",
  "行情":"คำคม",
  "交易":"ซื้อขาย",
  "货币":"สกุลเงิน",
  "资产":"สินทรัพย์",
  "注册":"ลงทะเบียน",
  "登录":"เข้าสู่ระบบ",
  "关于我们":"เกี่ยวกับเรา",
  "联系我们":"ติดต่อเรา",
  "公告中心":"ศูนย์ประกาศ",
  "条款说明":"ข้อกำหนดและเงื่อนไข",
  "用户协议":"ข้อตกลงการใช้",
  "隐私协议":"ข้อตกลงความเป็นส่วนตัว",
  "法律声明":"ประกาศทางกฎหมาย",
  "风险告知":"การแจ้งเตือนความเสี่ยง",
  "服务":"ให้บริการ",
  "充币":"ฝากเหรียญ",
  "提币":"ถอนเหรียญ",
  "新币申购":"การสมัครสมาชิกสกุลเงินใหม่",
  "AI赚币":"AI ได้รับเหรียญ",
  "产品":"ผลิตภัณฑ์",
  "永续合约":"สัญญาถาวร",
  "期货合约":"สัญญาซื้อขายล่วงหน้า",
  "币币交易":"การซื้อขายสกุลเงินดิจิตอล",
  "我的资产":"ทรัพย์สินของฉัน",
  "记录":"บันทึก",
  "可用":"มีอยู่",
  "折合":"แปลงแล้ว",
  "私募币种":"สกุลเงินตำแหน่งส่วนตัว",
  "私募币种上线,您可以在这里买到您觉得有潜力的新币":"เหรียญเฉพาะเจาะจงออนไลน์อยู่ คุณสามารถซื้อเหรียญใหม่ที่คุณคิดว่ามีศักยภาพได้ที่นี่",
  "名称":"ชื่อ",
  "价格":"ราคา",
  "4H涨跌":"4H ขึ้นและลง",
  "成交量":"ปริมาณ",
  "操作":"ดำเนินงาน",
  "为您的资产保驾护航":"ปกป้องทรัพย์สินของคุณ",
  "行业领先多重安全风控体系,7*24小时全年无休平台监控，全方位保护资产 安全":"ระบบควบคุมความเสี่ยงด้านความปลอดภัยชั้นนำในอุตสาหกรรม การตรวจสอบแพลตฟอร์มตลอด 24 ชั่วโมงทุกวัน การปกป้องความปลอดภัยของสินทรัพย์รอบด้าน",
  "多重":"หลายรายการ",
  "安全风控机制":"กลไกการควบคุมความเสี่ยงด้านความปลอดภัย",
  "全球领先的交易市场":"ตลาดการค้าชั้นนำของโลก",
  "轻松创建个人专属资产账户，探索、购买和交易全球的优质 交易品类":"สร้างบัญชีสินทรัพย์พิเศษส่วนตัวได้อย่างง่ายดายเพื่อสำรวจ ซื้อ และซื้อขายหมวดหมู่การซื้อขายคุณภาพสูงทั่วโลก",
  "品种":"ความหลากหลาย",
  "手机PC端均可使用":"ใช้งานได้ทั้งบนมือถือและพีซี",
  "随时随地开始交易":"เริ่มซื้อขายได้ทุกที่ทุกเวลา",
  "我们提供强大的图表分析工具：五十多种技术指标和盘面 分析工具。安全可靠、易于使用而又具备高阶投资者使用 的功能特点，成为在线投":"เรามีเครื่องมือวิเคราะห์แผนภูมิที่มีประสิทธิภาพ: ตัวบ่งชี้ทางเทคนิคและเครื่องมือวิเคราะห์ดิสก์มากกว่าห้าสิบรายการ ปลอดภัย เชื่อถือได้ ใช้งานง่าย และมีคุณสมบัติสำหรับนักลงทุนระดับสูง ทำให้เป็นแพลตฟอร์มการลงทุนออนไลน์",
  "点击下载":"คลิกเพื่อดาวน์โหลด",
  "安卓市场":"แอนดรอยด์มาร์เก็ต",
  "苹果商店":"ร้านแอปเปิ้ล",
  "私募币种限量上线,您可以在这里买到您觉得有潜力的新币":"เหรียญเฉพาะเจาะจงมีจำนวนจำกัดทางออนไลน์ คุณสามารถซื้อเหรียญใหม่ที่คุณคิดว่ามีศักยภาพได้ที่นี่",
  "24H涨跌":"ขึ้นและลงตลอด 24 ชั่วโมง",
  "探索无限可能":"สำรวจความเป็นไปได้ที่ไม่มีที่สิ้นสุด",
  "新币申购功能上线":"ฟังก์ชั่นการสมัครสมาชิกสกุลเงินใหม่ออนไลน์แล้ว",
  "开始使用":"เริ่มใช้",
  "AI赚币计划进行中":"อยู่ระหว่างดำเนินการตามแผนกองทุน AI",
  "开始AI赚币,稳定收益,高回报率,让您 躺着赚币":"เริ่มกองทุน AI ที่มีรายได้มั่นคงและอัตราผลตอบแทนสูง ช่วยให้คุณสร้างรายได้ขณะนอนราบ",
  "贷款功能上线":"ฟังก์ชั่นสินเชื่อออนไลน์อยู่",
  "当您没钱的时候,您可以申请贷款,最快 当天下发 ":"เมื่อคุณไม่มีเงินคุณสามารถสมัครสินเชื่อได้และจะออกให้ทันทีในวันเดียวกัน",
  "新币限量上线,您可以在这里买 到您觉得有潜力的新币":"เหรียญใหม่มีจำนวนจำกัด คุณสามารถซื้อเหรียญใหม่ที่คุณคิดว่ามีศักยภาพได้ที่นี่",
  "模拟交易":"การซื้อขายจำลอง",
  "限购":"วงเงินการซื้อ",
  "次":"อัตราที่สอง",
  "关闭模拟":"ปิดการจำลอง",
  "数量":"ปริมาณ",
  "请输入提币地址提币手续费为":"กรุณากรอกที่อยู่การถอนเงินค่าธรรมเนียมการถอนคือ",
  "提币手续费为":"ค่าธรรมเนียมการถอนสกุลเงินคือ",
  "请输入提币地址":"กรุณากรอกที่อยู่การถอนเงิน",
  "我已阅读并知晓":"ฉันได้อ่านและเข้าใจแล้ว",
  "贷款服务协议":"สัญญาการให้บริการสินเชื่อ",
  "level1": {
    "name": "ชื่อจริง",
    "address": "ที่อยู่ปัจจุบัน",
    "bank_number": "บัญชีธนาคาร",
    "wc": "ตกลง",
    "name_nodata": "ชื่อต้องไม่เว้นว่าง",
    "id_card_nodata": "หมายเลขประจำตัวประชาชนต้องไม่เว้นว่าง",
    "address_nodata": "ที่อยู่ต้องไม่เว้นว่าง",
    "bank_number_nodata": "บัญชีธนาคารต้องไม่เว้นว่าง",
    "input-username": "กรุณาใส่ชื่อจริงของท่าน",
    "zjhm": "หมายเลขประจำตัวประชาชน",
    "input-idcard": "โปรดใส่หมายเลขประจำตัวประชาชน",
    "input-address": "โปรดใส่ที่อยู่",
    "zjlx": "ประเภทบัตร",
    "qxzzjlx": "โปรดเลือกประเภทบัตร",
    "sfz": "บัตรประจำตัวประชาชน",
    "hz": "หนังสือเดินทาง",
    "jsz": "ใบขับขี่",
    "khh": "ธนาคารบัญชี",
    "qsrkhh": "กรุณากรอกธนาคาร",
    "yhkh": "บัญชีธนาคาร",
    "qsryhkh": "กรุณาใส่เลขบัญชีธนาคาร",
    "gjlb": "รายการประเทศ",
    "qxzgjlb": "กรุณาเลือกประเทศ / ภูมิภาค"
  },
  "my": {
    "mqrcode": "รหัสคิวอา ของฉัน",
    "as": "ตั้งค่า",
    "pc": "การรับรองระดับเบื้องต้น",
    "ac": "ใบรับรองระดับอาวุโส",
    "ms": "แบ่งปัน",
    "me": "รายได้ของฉัน",
    "zsr": "รายได้รวม",
    "mp": "โปรโมชั่นของฉัน",
    "yqhy": "เชิญเพื่อน",
    "ar": "บันทึกบัญชี",
    "hc": "ศูนย์ช่วยเหลือ",
    "nodata": "ไม่มีข้อมูล",
    "med": "รายละเอียดรายได้",
    "aes": "รายได้สะสม (USDT)",
    "one": "รุ่นที่หนึ่ง",
    "two": "รุ่นที่สอง",
    "three": "รุ่นที่สาม",
    "four": "รุ่นที่สี่",
    "ones": "จำนวนรุ่นที่หนึ่ง",
    "twos": "จำนวนรุ่นที่สอง",
    "threes": "จำนวนรุ่นที่สาม",
    "fours": "จำนวนรุ่นที่สี่",
    "promotion": "จำนวนโปรโมชั่น",
    "customers": "รายได้ของฉัน",
    "wdzc": "ทรัพย์สินของฉัน",
    "wdzc1": "ทรัพย์สินของฉัน",
    "wyfx": "แบ่งปัน",
    "wdsy": "รายได้ของฉัน",
    "wdtg": "โปรโมชั่นของฉัน",
    "zhjl": "บันทึกบัญชี",
    "zxkf": "ติดต่อเรา",
    "wdxx": "ข้อความของฉัน",
    "smrz":"การรับรองความถูกต้อง KYC",
    "sfyz":"การรับรองความถูกต้อง KYC"
  },
  "footer": {
    "home": "หน้าแรก",
    "quotation": "ตลาด",
    "currency": "ธุรกรรมสกุลเงิน",
    "lever": "สัญญา",
    "my": "บัญชีผู้ใช้",
    "lc": "ถือเงินเพื่อรับดอกเบี้ย"
  },
   home:{
      user:'ทางเลือกทั่วไปของผู้ใช้',
      start:'เริ่มต้นการซื้อขาย',
      trading:'ซื้อขายสินค้า',
      fee:'ค่าธรรมเนียมการจัดการขั้นต่ำ',
      co:'บริษัท',
      varieties:'ซื้อขายพันธุ์',
      leading:'เป็นผู้นำด้านนวัตกรรมและการสำรวจ web3',
      market:'แนวโน้มตลาดการซื้อขายสินค้า',
      explore:'สำรวจความเป็นไปได้ที่ไม่มีที่สิ้นสุด',
      newcurrency:'ฟังก์ชั่นการสมัครสมาชิกสกุลเงินใหม่ออนไลน์แล้ว!',
      alimited:'เหรียญใหม่ออนไลน์อยู่ คุณสามารถซื้อเหรียญใหม่ที่คุณคิดว่ามีศักยภาพได้ที่นี่',
      get_start:'เริ่มต้น',
      ai_coin:'กำลังดำเนินการแผนการรับเหรียญ สระขุด',
      ai_text:'เริ่มรับเหรียญด้วย สระขุด รายได้ที่มั่นคง อัตราผลตอบแทนสูง ให้คุณรับเหรียญขณะนอนราบ',
      loan:'ฟังก์ชั่นสินเชื่อออนไลน์อยู่',
      loan_text:'เมื่อคุณไม่มีเงินคุณสามารถสมัครสินเชื่อได้และจะออกให้ทันทีในวันเดียวกัน',
      mobile_pc:'ใช้โดยพยาบาลบนพีซีมือถือ',
      pc_anytime:'เริ่มซื้อขายได้ทุกที่ทุกเวลา:',
      pc_text:'เรามีเครื่องมือวิเคราะห์แผนภูมิที่มีประสิทธิภาพ: ตัวบ่งชี้ทางเทคนิคและเครื่องมือวิเคราะห์ดิสก์มากกว่าห้าสิบรายการ เลเวอเรจที่ปลอดภัย เชื่อถือได้ ใช้งานง่ายและฟีเจอร์เลเวอเรจสูงกลายเป็นแพลตฟอร์มมาตรฐานสำหรับการลงทุนออนไลน์。',
      mobile_down:'คลิกเพื่อดาวน์โหลด',
      mobile_android:'แอนดรอยด์มาร์เก็ต',
      mobile_ios:'ร้านแอปเปิ้ล',
      open_text:'คุณสามารถสมัครบัญชีซื้อขายจริงหรือลองใช้บัญชีทดลองได้ฟรีโดยมีค่าใช้จ่ายหนึ่งในสาม',
      open_account:'บัญชี',
      tocomplete:'ทำให้สมบูรณ์',
      walletlogin:'เข้าสู่ระบบกระเป๋าเงิน',
      thedoor:'ประตูสู่การลงทุนและการจัดการทางการเงิน',
      weare:'เราเป็นสถานที่ที่เชื่อถือได้มากที่สุดในการจัดการการแลกเปลี่ยนเงินตราต่างประเทศและดิจิทัล',
      emailaddress:'ที่อยู่อีเมล',
      allprices:'ราคาทั้งหมด',
      chart:'แผนภูมิแนวโน้มโลหะมีค่า',
      gold:'Blkketf เป็นซอฟต์แวร์การซื้อขายที่ใช้งานได้จริง คุณสามารถดูแผนภูมิแนวโน้มได้โดยตรงจากหน้าแรก',
      more:'ฟังก์ชั่นที่เป็นประโยชน์มากขึ้น',
      weprovide:'เรามอบฟังก์ชันการรับสกุลเงิน สระขุด สินเชื่อ และการสมัครสมาชิกสกุลเงินใหม่ให้กับคุณ',
      zzc:'สินทรัพย์รวม',
      gmjy:'คุณสามารถซื้อสกุลเงินดิจิทัลจำนวนเล็กน้อยและเริ่มการซื้อขายได้ทันที'
    },
    propagate:{
      ai:'ข้อมูลเบื้องต้นเกี่ยวกับพูลการขุดอัจฉริยะ',
      how:'รู้เบื้องต้นเกี่ยวกับผู้จัดการแฟรนไชส์กองทุน',
      brick:'สกุลเงินอิฐ',
    },
    propagatebuy:{
      joinai:'เข้าร่วมกลุ่มการขุดอัจฉริยะ',
      risk:'ความเสี่ยง 0 ผลตอบแทนที่มั่นคง',
      daily:'รายได้รายวันจะถูกแจกจ่ายไปยังบัญชีกระเป๋าเงิน USDT ของคุณ',
      zero:'กองทุนคุมขังของคุณไม่มีความเสี่ยง',
      youcan:'คุณสามารถถอนเงินของคุณได้ตลอดเวลา',
      airobot:'หุ่นยนต์ AI ทำงานทุกวันตลอด 24 ชั่วโมง 365*',
    },
  "index": {
    "wdzc": "สินทรัพย์ของฉัน (USDT)",
    "dl": "เข้าสู่ระบบ",
    "zxkf": "ติดต่อเรา",
    "increase": "กระดานเคลื่อนไหว",
    "usercenter": "ศูนย์ส่วนบุคคล",
    "security": "ศูนย์รักษาความปลอดภัย",
    "address": "ที่อยู่การถอน",
    "aboutus": "เกี่ยวกับเรา",
    "vol": "ปริมาณ 24H",
    "kjcb": "ฝากเงิน",
    "zcbz": "BTC, USDT...",
    "logout":"ออกจากระบบ",
    "language":"ภาษา"
  },
  "transaction": {
    "buy": "ซื้อเข้า",
    "sell": "ขายออก",
    "pwd": "รหัสผ่านการทำธุรกรรม",
    "inputnum": "ปริมาณนำเข้า",
    "limit": "ขีดจำกัด",
    "avaiable": "ใช้ได้",
    "turnover": "ยอดที่ทำรายการ",
    "handicap": "แฮนดิแคป",
    "number": "ปริมาณ",
    "nonumber": "ปริมาณที่ไม่สำเร้จ",
    "numbered": "ปริมาณที่สำเร้จ",
    "price": "ราคา",
    "marketprice": "ราคาตลาด",
    "cancel": "ยกเลิก",
    "time": "เวลา",
    "nomore": "หมดชั่วคราว",
    "nodata": "ไม่มีบันทึก",
    "getmore": "โหลดเพิ่ม",
    "mycommission": "คำสั่งซื้อของฉัน",
    "currentbuy": "คำสั่งซื้อปัจจุบัน (ซื้อเข้า)",
    "currentsell": "คำสั่งซื้อปัจจุบัน (ขายออก)",
    "his": "คำสั่งซื้อในอดีต (สำเร็จ)",
    "currency": "สกุลเงิน",
    "option": "ดำเนินการ",
    "wtime": "หมดเวลา",
    "wnumber": "จำนวนเงินที่สำเร็จ",
    "wprice": "ราคาเต็ม"
  },
  "mk": {
    "high": "สูง",
    "low": "ต่ำ",
    "vol": "ปริมาณ 24H",
    "newPrice": "ราคาล่าสุด",
    "product": "สินค้า",
    "name":"ชื่อ",
    "rank": "กระดานเคลื่อนไหว"
  },
  "deals": {
    "issue_time": "เวลาเปิดขาย",
    "issue_number": "จำนวนเปิดขาย",
    "white_book": "กระดาษสีขาว",
    "weburl": "เว็บไซต์อย่างเป็นทางการ",
    "video_url": "วีดีโอแนะนำ",
    "introduction": "บทนำ",
    "onhand": "1 ล็อต เท่ากับ",
    "position": "ยอดที่ถือปัจจุบัน",
    "leverorder": "คำสั่งเลเวอเรจ",
    "leverposition": "ยอดเลเวอเรจ",
    "inputprice": "ใส่ราคา",
    "inputmul": "ใส่เท่าตัว",
    "selectmul": "เลือกเท่าตัว",
    "onehand": "1 ล็อต เท่ากับ",
    "hand": "ล็อตการซื้อขาย",
    "marketval": "มูลค่าตลาดตามสัญญา",
    "bond": "เงินประกัน",
    "balance": "คงเหลือ",
    "type": "ประเภท",
    "risk": "อัตราความเสี่ยง",
    "total": "กำไรและขาดทุนของยอดที่ถือทั้งหมด:",
    "onekey": "ชำระบัญชีคลิกเดียว",
    "makemore": "(ยาวไป)",
    "makeless": "(สั้น)",
    "current": "คำสั่งซื้อปัจจุบัน",
    "all": "ทั้งหมด",
    "weing": "คำสั่งที่เปิดอยู่",
    "tding": "กำลังดำเนินการ",
    "ping": "กำลังคัทลอส ",
    "pied": "คัทลอสแล้ว",
    "ceiled": "ยกเลิกคำสั่งซื้อ",
    "weprice": "ค่าธรรมเนียม",
    "oprice": "ราคาเปิด",
    "nowprice": "ราคาปัจจุบัน",
    "zyprice": "ขายทำกำไร",
    "zsprice": "ราคาคัทลอส",
    "canbond": "ยอดที่สามารถใช้ได้",
    "optime": "เวลาเปิด",
    "pgtime": "เวลาปิด",
    "znum": "ปริมาณที่แปลงแล้ว",
    "gprice": "ค่าธรรมเนียมค้างคืน",
    "pcang": "คัทลอส ",
    "revoke": "ยกเลิกคำสั่งซื้อ",
    "fee": "ค่าธรรมเนียม",
    "you": "ซื้อขายในราคาที่ดีที่สุดในปัจจุบัน"
  },
  "assets": {
    "copy": "คัดลอก",
    "avaiable": "ใช้ได้",
    "lock": "ถูกล็อก",
    "conversion": "แลกเปลี่ยน",
    "exact": "บัญชีซื้อขายหลักทรัพย์",
    "num": "ปริมาณ",
    "time": "เวลา",
    "all": "ทั้งหมด",
    "canuse": "ใช้ได้",
    "cmoney": "ฝากเงิน",
    "tmoney": "ถอนเงิน",
    "caddress": "ที่อยู่เงินฝาก",
    "copyaddress": "คัดลอกที่อยู่",
    "taddress": "ที่อยู่การถอน",
    "taddressm": "กรุณากรอกที่อยู่ถอนเงิน",
    "rate": "ค่าธรรมเนียม",
    "dnum": "ยอดที่เข้าบัญชี",
    "more": "โหลดเพิ่ม",
    "nodata": "ไม่มีบันทึก",
    "yczc": "ซ่อนยอดคงเหลือที่เป็น0",
    "total":"การแปลงสินทรัพย์ (USDT)"
  },
  "td": {
    "drecord": "บันทึกคำสั่งซื้อ",
    "orecord": "บันทึกคำสั่งซื้อที่สำเร็จ",
    "filter": "กรอง",
    "dstatus": "สถานะคำสั่งซื้อ",
    "nofinish": "ยังไม่สำเร็จ",
    "finished": "สำเร็จ",
    "ceiled": "ยกเลิก",
    "reset": "รีเซ็ต",
    "confirm": "ตกลง",
    "time": "เวลา",
    "num": "ปริมาณ",
    "price": "ราคา",
    "ptime": "เวลาคำสั่งซื้อ",
    "receiver": "ผู้รับเงิน",
    "open": "ธนาคารบัญชี",
    "pwd": "รหัสผ่านการทำธุรกรรม",
    "ppwd": "โปรดใส่รหัสผ่านการทำธุรกรรม",
    "sure": "ตกลง",
    "realName": "ชื่อจริง",
    "pnum": "โปรดใส่จำนวน",
    "buyNum": "ปริมาณซื้อ",
    "currency": "สกุลเงิน"
  },
  "fat": {
    "ceil": "ยกเลิก",
    "num": "ปริมาณ",
    "submit": "สั่งซื้อ",
    "pwd": "รหัสผ่านการทำธุรกรรม",
    "ppwd": "โปรดใส่รหัสผ่านการทำธุรกรรม",
    "sure": "ยืนยันสั่งซื้อ",
    "auHigh": "ใบรับรองระดับอาวุโส"
  },
  "auth": {
    "bh": "ปฏิเสธ",
    "mycenter": "ศูนย์ส่วนบุคคล",
    "test": "ยืนยันตัวตน",
    "testing": "กำลังตรวจสอบ",
    "name": "ชื่อ",
    "account": "บัญชีผู้ใช้",
    "id_card_face": "โปรดอัพโหลดด้านหน้าของบัตรประชาชน",
    "id_card_back": "โปรดอัพโหลดด้านหลังของบัตรประชาชน",
    "updata": "ส่ง",
    "updata_again": "ส่งใหม่"
  },
  "code": {
    "notice": "ประกาศ"
  },
  "safe": {
    "title": "ความปลอดภัยของบัญชี",
    "center": "ศูนย์รักษาความปลอดภัย",
    "yysz": "ตั้งค่าภาษา",
    "ssms": "โหมดมืด",
    "gywm": "เกี่ยวกับเรา",
    "lgpwd": "ใส่รหัสผ่าน",
    "resetpwd": "เปลี่ยนรหัสผ่าน",
    "paccount": "โปรดใส่หมายเลขโทรศัพท์หรืออีเมล",
    "reset": "แก้ไข",
    "ceil": "ยกเลิก",
    "pcode": "รหัสยืนยัน",
    "sure": "ยืนยัน",
    "newPwd": "รีเซ็ตรหัสผ่าน",
    "ppwd": "โปรดใส่รหัสผ่าน",
    "reppwd": "โปรดใส่รหัสผ่านอีกครั้ง",
    "repwd": "รีเซ็ตรหัสผ่าน",
    "zpwd": "รหัสผ่านการทำธุรกรรม"
  },
  "met": {
    "open": "ชื่อธนาคาร",
    "bank": "บัญชีธนาคาร",
    "realname": "ชื่อจริง",
    "save": "บันทึก",
    "popen": "โปรดใส่ชื่อธนาคาร",
    "pbank": "โปรดใส่เลขที่บัญชี",
    "pname": "กรุณาใส่ชื่อจริงของท่าน"
  },
  "ads": {
    "tas": "ที่อยู่การถอน",
    "address": "ที่อยู่",
    "noads": "คุณไม่มีที่อยู่",
    "adds": "ที่อยู่",
    "remark": "หมายเหตุ",
    "cel": "ลบ"
  },
  "jc": {
    "ppwd": "โปรดใส่รหัสผ่าน"
  },
  "lg": {
    "qbdl":"เข้าสู่ระบบกระเป๋าเงิน",
    "welcome": "สวัสดี! ต้อนรับเข้าสู่ระบบ",
    "lgtel": "เข้าสู่ระบบบนมือถือ",
    "lgeml": "เข้าสู่ระบบด้วยอีเมล",
    "paccount": "เบอร์โทรศัพท์ หรือ E-mail",
    "ppwd": "โปรดใส่รหัสผ่าน",
    "ppwd2": "โปรดยืนยันรหัสผ่าน",
    "pcode": "รหัสยืนยัน",
    "qsryqm": "โปรดใส่รหัสเชิญ",
    "noaccount": "ยังไม่มีบัญชี",
    "register": "ลงทะเบียน",
    "phregister": "ลงทะเบียนโดยโทรศัพท์",
    "emregister": "ลงทะเบียนโดยอีเมล",
    "pphone": "เบอร์โทรศัพท์",
    "ceil": "ยกเลิก",
    "send": "รับรหัสยืนยัน",
    "sure": "ตกลง",
    "email": "โปรดใส่อีเมล",
    "emtest": "ยืนยันอีเมล",
    "pemcode": "รหัสยืนยัน",
    "ppcode": "โปรดใส่รหัสยืนยันทางโทรศัพท์",
    "ftpwd": "ลืมรหัสผ่าน",
    "ptext": "โปรดใส่หมายเลขโทรศัพท์หรืออีเมล",
    "yzm": "รหัสยืนยัน",
    "mm": "รหัสผ่าน",
    "qrmm": "ยืนยันรหัสผ่าน",
    "language":"ภาษา",
    "qregister":"ลงทะเบียน",
    "lgs":"เข้าสู่ระบบ",
    "ftpwds":"ลืมรหัสผ่าน",
    "kjzc": "ติดต่อเราเพื่อลงทะเบียนด่วน",
    "kjzc1": "ไม่สามารถรับแคปต์ชา?",
    "kjzc2": "ลงทะเบียนด่วน",
    "wyzx": "ฉันรู้แล้ว",
    "qtxyxzh": "สำคัญ: โปรดกรอกที่อยู่อีเมลหรือหมายเลขโทรศัพท์มือถือที่ถูกต้อง ซึ่งสามารถใช้เพื่อเรียกรหัสผ่านของคุณ",
    "next": "ขั้นตอนต่อไป"
  },
  "gjrz": {
    "title": "ใบรับรองระดับอาวุโส",
    "t1": "1. รองรับรูปภาพ JPG, JPEG หรือ PNG น้อยกว่า 8M",
    "t2": "2. ภาพถ่ายบัตรต้องชัดเจนและไม่อนุญาตให้มีการดัดแปลงหรือมีสิ่งปกปิด ต้องเห็นรูปหน้า เลขบัตรและสกุลชัดเจน ",
    "t3": "3. รูปถ่ายต้องไม่สวมหมวก แนะนำไม่ให้ผู้ถือบัตรแต่งหน้า มองเห็นใบหน้าที่ชัดเจนและเห็นไหล่สองข้าง",
    "t4": "ตกลง",
    "bh": "ปฏิเสธ",
    "shz": "กำลังตรวจสอบ",
    "shtg": "ผ่านการตรวจสอบ",
    "sczjz": "อัพโหลดรูปบัตรประชาชน",
    "sczjzmz": "โปรดอัพโหลดด้านหน้าของบัตรประชาชน",
    "sczjbmz": "โปรดอัพโหลดด้านหลังของบัตรประชาชน",
    "scgrqmz": "โปรดอัพบัตรประชาชนและลายเซ็น"
  },
  "chongzhi": {
    "title": "ฝากเงิน",
    "cbjl": "บันทึกการฝาก",
    "t1": "ปริมาณ",
    "t2": "โปรดใส่จำนวน",
    "t3": "บรรยาย(ไม่จำเป็น)",
    "t4": "โปรดใส่คำอธิบาย",
    "t5": "รูปภาพคูปอง",
    "t6": "ตกลง",
    "t7": "ชื่อลูกโซ่",
    "t8": "รหัสคิวอาร์",
    "t9": "บันทึกรหัสคิวอาร์",
    "t10": "ที่อยู่เงินฝาก",
    "t11": "คัดลอก",
    "zy": "สำคัญ",
    "tips1": "โปรดอย่าเติมสินทรัพย์ใด ๆ ที่ไม่ได้อยู่ในสกุลเงินนี้ไปยังที่อยู่ด้านบน มิฉะนั้นจะไม่สามารถเรียกสินทรัพย์กลับมาได้",
    "tips2": "1. ความเข้ากันได้กับกระเป๋าเงิน/แพลตฟอร์ม: นั่นคือ เครือข่ายได้รับการสนับสนุน หากแพลตฟอร์มเป้าหมายไม่สนับสนุนเครือข่ายการถอนเงินของคุณ สินทรัพย์จะไม่สามารถเรียกคืนได้",
    "tips3": "2. เครือข่ายเติมเงินและแพลตฟอร์มเป้าหมายเหมือนกัน หากคุณเลือกที่อยู่เป้าหมายคือเครือข่าย Ethereum แต่การเติมเงินเลือกสมาร์ทเชน TRC20 คุณอาจไม่สามารถเรียกข้อมูลสินทรัพย์ดิจิทัลของคุณได้",
    "tips4": "3. ตรวจสอบให้แน่ใจว่าที่อยู่และจำนวนเงินของคุณถูกต้องก่อนทำการชาร์จ",
    "tips5": "คำเตือน: เนื่องจากการไม่เปิดเผยตัวตนและความเป็นส่วนตัวของเครือข่ายที่ถูกบล็อก เมื่อคุณป้อนข้อมูลผิด คุณจะสูญเสียทรัพย์สินที่เกี่ยวข้อง โปรดตรวจสอบที่อยู่และปริมาณการเติมเงินของคุณอย่างระมัดระวัง"
  },
  "tibi": {
    "title": "ถอน",
    "tbjl": "บันทึกการถอน",
    "t1": "ที่อยู่การถอน",
    "t2": "กรุณากรอกที่อยู่ถอนเงิน",
    "t3": "จำนวนการถอน",
    "qsrtbsl": "โปรดใส่จำนวนการถอน",
    "t4": "ถอนขั้นต่ำ",
    "t5": "รหัสผ่านการทำธุรกรรม",
    "t6": "โปรดใส่รหัสผ่านการทำธุรกรรม",
    "t7": "ค่าธรรมเนียม",
    "t8": "ยอดที่เข้าบัญชี",
    "t9": "ตกลง",
    "sc": "ลบ",
    "bj": "แก้ไข",
    "bq": "ป้ายกำกับ (บันทึก)",
    "qsrbq": "กรุณาใส่ป้ายกำกับ",
    "yhktx": "ถอนบัตรธนาคาร",
    "yhmc": "ชื่อธนาคาร",
    "qsryhmc": "โปรดใส่ชื่อธนาคาร",
    "yhzh": "บัญชีธนาคาร",
    "qsryhzh": "โปรดใส่เลขบัญชีธนาคาร",
    "gjhkdm": "รหัสโอนเงินระหว่างประเทศ",
    "qsrgjhkdm": "โปรดใส่รหัสโอนเงินระหว่างประเทศ",
    "yhdz": "ที่อยู่ธนาคาร",
    "qsryhdz": "โปรดใส่ที่อยู่ธนาคาร",
    "skrxm": "ชื่อผู้รับเงิน",
    "qsrskrxm": "โปรดใส่ชื่อผู้รับเงิน",
    "skrdh": "โทรศัพท์ผู้รับเงิน",
    "qsrskrdh": "โปรดใส่หมายเลขโทรศัพท์ผู้รับเงิน",
    "skrdz": "ที่อยู่ผู้รับเงิน",
    "qsrskrdz": "โปรดใส่ที่อยู่ผู้รับเงิน"
  },
  "huazhuan": {
    "t4": "โปรดใส่จำนวน",
    "ky": "ใช้ได้",
    "t10": "ตกลง"
  },
  "banner": {
    "title": "รายละเอียด"
  },
  "download": {
    "t1": "การทำธุรกรรมทุกที่",
    "xz": "ดาวน์โหลด"
  },
  "xgdlmm": {
    "title": "แก้ไขรหัสผ่านเข้าสู่ระบบ",
    "zh": "บัญชี",
    "yzm": "รหัสยืนยัน",
    "yzmts": "รหัสยืนยัน",
    "hqyzm": "รับรหัสยืนยัน",
    "mm": "รหัสผ่าน",
    "qrmm": "ยืนยันรหัสผ่าน",
    "qr": "ยืนยัน",
    "zhts":"โทรศัพท์มือถือหรืออีเมล",
    "mmts":"รหัสผ่านประกอบด้วยตัวอักษรและตัวเลขความยาว 6-12 หลัก"
  },
  "sztkmm": {
    "title": "ตั้งรหัสผ่านการทำธุรกรรม",
    "dlmm": "ใส่รหัสผ่าน",
    "dlmmts": "โปรดใส่รหัสผ่านของคุณ",
    "xmm": "รหัสผ่านใหม่",
    "mmts": "ความยาวรหัสผ่าน 6 หลัก",
    "qrmm": "ยืนยันรหัสผ่าน",
    "qr": "ยืนยัน",
    "qd": "ตกลง",
    "sztkts": "เคล็ดลับ: โปรดไปตั้งรหัสผ่านการทำธุรกรรมที่ศูนย์ความปลอดภัย"
  },
  "rule": {
    "title": "แนะนำผลิตภัณฑ์",
    "title2": "กติกา",
    "title3": "กิจกรรม"
  },
  "news": {
    "title": "ข้อความของฉัน",
    "ckxq": "ดูรายละเอียด",
    "gg": "ประกาศ"
  },
  "search": {
    "qx": "ยกเลิก"
  },
  "wdtg": {
    "wdyqlj": "ลิงค์คำเชิญของฉัน",
    "wdyqm": "รหัสคำเชิญของฉัน",
    "schbyq": "สร้างคำเชิญโปสเตอร์",
    "ljtgsy": "รายได้จากโปรโมชั่นสะสม",
    "tkrs": "จำนวนคำเชิญ",
    "ljyj": "คอมมิชชั่นสะสม",
    "yjmx": "รายละเอียดค่าคอมมิชชั่น",
    "ljyjjl": "รางวัลคอมมิชชั่นสะสม (usdt)",
    "ljsy": "รายได้สะสม",
    "ljyqjl": "รางวัลคำเชิญสะสม (usdt)",
    "fxd": "แชร์ไปยัง",
    "bctp": "บันทึกภาพ",
    "qx": "ยกเลิก",
    "t3": "กดภาพค้างไว้เพื่อจดจำ หรือสแกน"
  },
  "bzhl": {
    "title": "กองทุนเอไอ",
    "gz": "กติกา",
    "tgdd": "คำสั่งเอสโครว์",
    "zztgdzj": "กองทุนภายใต้การดูแล",
    "yjjrsy": "รายได้วันนี้",
    "ljsy": "รายได้สะสม",
    "tgzdd": "คำสั่งที่รอดำเนินการ",
    "cljxcp": "ผลิตภัณฑ์เชิงกลยุทธ์",
    "dbxe": "จำกัดยอดเดียว",
    "rsyl": "อัตราผลตอบแทนรายวัน",
    "zq": "รายสัปดาห์",
    "qmr": "ซื้อทันที",
    "bbzhzc": "ทรัพย์สินทางบัญชี",
    "dd": "คำสั่ง",
    "buy": "ซื้อเข้า",
    "jxcp": "สินค้าแนะนำ",
    "ckdd": "ตรวจสอบคำสั่งซื้อ",
    "gd": "มากกว่า",
    "xzbzts": "ง่ายและปลอดภัย สามารถเลือกเงินปันผลได้หลายสกุลเงิน",
    "qtbz": "กองทุนอื่นๆ"
  },
  "bzhlgm": {
    "qtzq": "USDT รอบ 7 วัน",
    "rsyl": "อัตราผลตอบแทนรายวัน (%)",
    "lczq": "การเงินรายสัปดาห์",
    "dbxe": "จำกัดยอดเดียว",
    "pxsj": "เวลาปันผล",
    "mr": "ทุกวัน",
    "dqfh": "ผลตอบแทนเมื่อครบกำหนด",
    "tgzj": "ทุนการดูแล",
    "tqsh": "รับการไถ่ถอน",
    "yjsy": "ผลตอบแทนโดยประมาณ (USDT)",
    "kyzc": "สินทรัพย์ที่มีอยู่ (USDT)",
    "cpjs": "รายละเอียดสินค้า",
    "tgje": "ยอดเงินการดูแล",
    "qsrtgje": "โปรดใส่ยอดเงินการดูแล",
    "qb": "ทั้งหมด",
    "rm": "ซื้อทันที",
    "cpzq": "อายุผลิตภัณฑ์",
    "gz": "เข้าใจกฎและสิทธิ์"
  },
  "bzhlwdtg": {
    "title": "สถานะคำสั่งซื้อ",
    "tgz": "ระหว่าการดูแล",
    "ywc": "สำเร็จ",
    "ysh": "ถอนคืนแล้ว",
    "tgje": "ยอดเงินการดูแล/จำนวนวันรอบสัปดาห์",
    "rsyl": "อัตราผลตอบแทนรายวัน",
    "yhl": "กำไร/วันคงเหลือ",
    "xdsj": "เวลาคำสั่งซื้อ",
    "sh": "การไถ่ถอน",
    "ddxq": "รายละเอียดคำสั่งซื้อ",
    "ddh": "เลขที่ใบสั่งซื้อ"
  },
  "bzjj": {
    "t1": "สร้างรายได้ทุกวัน",
    "cpld": "จุดเด่นของผลิตภัณฑ์",
    "scsq": "ฝากและรับได้ตลอดเวลา",
    "pxzq": "รอบการจ่ายเงินปันผล",
    "mtxf": "ออกทุกวัน",
    "hqlx": "ดอกเบี้ยออมทรัพย์",
    "zj": "ทุน 100%",
    "aqbz": "ความปลอดภัย",
    "jjrsy": "รายได้วันหยุด",
    "sybjd": "รายได้ไม่ขาดตอน",
    "bjd": "ไม่ขาดตอน",
    "cgcrh": "หลังฝากสำเร็จ",
    "dtqx": "วันหยุด",
    "jglz": "ตัวอย่างเช่น",
    "syjs": "การคำนวณรายได้",
    "cont2": "ขั้นต่ำ: 10000U× 0.3%-30U",
    "cont3": "สูงสุด: 10000U× 0.5%-50U",
    "gywyj": "เกี่ยวกับค่าผิดสัญญา",
    "wycy": "อยากมีส่วนร่วม"
  },
  "zyzs": {
    "title": "ทำกำไร และหยุดการสูญเสีย",
    "zy": "ทำกำไร",
    "zs": "หยุดการสูญเสีย",
    "qsrzyjg": "โปรดใส่ราคาทำกำไร",
    "qsrzsjg": "โปรดใส่ราคาหยุดการสูญเสีย",
    "scjg": "ราคาตลาด",
    "wxts": "เคล็ดลับ:",
    "qr": "ยืนยัน"
  },
  "bbjy": {
    "mr": "ซื้อเข้า",
    "mc": "ขายออก",
    "mai": "ซื้อ",
    "sell": "ขาย",
    "xj": "ขีดจำกัด",
    "sj": "ราคาตลาด",
    "pk": "แฮนดิแคป",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "mrl": "ยอดซื้อเข้า",
    "ss": "ปริมาณ",
    "mcl": "ปริมาณขายออก",
    "ky": "ใช้ได้",
    "km": "ซื้อได้",
    "ksell": "พร้อมขาย",
    "jye": "ยอดที่ทำรายการ",
    "dqwt": "คำสั่งซื้อปัจจุบัน",
    "lswt": "ค่าคอมมิชชั่นอดีต",
    "jj": "บทนำ",
    "wtzl": "รวม",
    "wtjg": "ราคาคอมมิชชั่น",
    "ycjl": "ปริมาณ",
    "cjjj": "ราคาซื้อขายเฉลี่ย",
    "cd": "ยกเลิกคำสั่งซื้อ",
    "xd": "สั่งซื้อ",
    "ywc": "สำเร็จ",
    "ycd": "ยกเลิกคำสั่งซื้อ",
    "wqcj": "เสร็จสมบูรณ์",
    "zx": "เลือกเอง",
    "scjg": "ราคาตลาด",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "qx": "ยกเลิก"
  },
  "hyjy": {
    "mai": "ซื้อ",
    "sell": "ขาย",
    "kc": "เปิดการขาย",
    "pc": "คัทลอส ",
    "cc": "ถือเหรียญ",
    "kp": "ปิด",
    "kpc": "ปิดระยะสั้น",
    "kcc": "ตำแหน่งที่ถือได้",
    "kkd": "เปิดระยะยาว",
    "kpd": "ปิดระยะยาว",
    "kkk": "เปิดสั้น",
    "xj": "ขีดจำกัด",
    "sj": "ราคาตลาด",
    "xjwt": "จำกัดคำสั่งซื้อ",
    "sjwt": "คำสั่งของตลาด",
    "pk": "แฮนดิแคป",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "gg": "เลเวอเรจ",
    "tzgg": "ปรับเลเวอเรจ",
    "ggbs": "เลเวอเรจเท่าตัว",
    "mrl": "ยอดซื้อเข้า",
    "ky": "ใช้ได้",
    "jye": "ยอดที่ทำรายการ",
    "dqwt": "คำสั่งซื้อปัจจุบัน",
    "lswt": "ค่าคอมมิชชั่นอดีต",
    "ptwt": "คำสั่งซื้อทั่วไป",
    "dqwtmr": "คำสั่งซื้อปัจจุบัน (ซื้อเข้า)",
    "dqwtmc": "คำสั่งซื้อปัจจุบัน (ขายออก)",
    "hywt": "สัญญาคำสั่งซื้อ",
    "jj": "บทนำ",
    "wtzl": "รวม",
    "wtjg": "ราคาคอมมิชชั่น",
    "ycjl": "ปริมาณ",
    "cjjj": "ราคาซื้อขายเฉลี่ย",
    "cd": "ยกเลิกคำสั่งซื้อ",
    "xd": "สั่งซื้อ",
    "wqcj": "เสร็จสมบูรณ์",
    "ywc": "สำเร็จ",
    "ycd": "ยกเลิกคำสั่งซื้อ",
    "zx": "เลือกเอง",
    "scjg": "ราคาตลาด",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "mrzd": "ซื้อนาน",
    "mrpk": "ซื้อสั้น",
    "mczk": "ขายระยะสั้น",
    "mcpd": "ขายระยะยาว",
    "mrkdkz": "ซื้อเปิดยาว (ขาขึ้น)",
    "mrpkkz": "ซื้อชอร์ต (ขาขึ้น)",
    "mckkkd": "ขาย open short (ขาลง)",
    "mcpdkd": "ขายทรงตัวยาว (ขาลง)",
    "yxhy": "สัญญาถาวร",
    "dc": "หลายตำแหน่ง",
    "syl": "อัตราผลตอบแทน",
    "bzjl": "อัตราเงินประกัน",
    "tzbzj": "ปรับเงินประกัน",
    "zyzs": "ทำกำไร และหยุดการสูญเสีย",
    "zhang": "ปริมาณ",
    "qblx": "ทุกประเภท",
    "qb": "ทั้งหมด",
    "ccjg": "ราคาตำแหน่ง",
    "ccsl": "จำนวนตำแหน่ง",
    "yk": "กำไรขาดทุน",
    "ccsj": "เวลาถือ",
    "zy": "ทำกำไร",
    "zs": "หยุดการสูญเสีย",
    "zje": "ยอดรวม",
    "kcs": "จำนวนตำแหน่งที่เปิดรับ",
    "kcjg": "ราคาเปิด",
    "ss": "ล็อต",
    "hand": "1 ล็อต =",
    "qx": "ยกเลิก",
    "qr": "ยืนยัน",
    "qbcd":"ยกเลิกคำสั่งซื้อทั้งหมด"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "มอบหมายที่รอดำเนินการ",
    "cj": "ดีล",
    "jj": "บทนำ",
    "sj": "เวลา",
    "fx": "ทิศทาง",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "mr": "ซื้อเข้า",
    "mc": "ขายออก",
    "mp": "คำสั่งซื้อ",
    "sp": "คำสั่งขาย",
    "slb": "ปริมาณ",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd": "More",
    "ft": "ภาพรอง",
    "zt": "ภาพหลัก",
    "sdt": "แผนที่ความลึก",
    "zx": "เลือกเอง",
    "djck": "คลิกเพื่อดู"
  },
  "zhjl": {
    "cbtb": "ฝากและถอน",
    "jymx": "รายละเอียดการทำธุรกรรม",
    "tgyj": "ค่าคอมมิชชั่นโปรโมชั่น",
    "wwc": "ยังไม่สำเร็จ",
    "ywc": "สำเร็จ"
  },
  "zwsj": {
    "title": "ไม่มีข้อมูล"
  },
  "bzxz": {
    "title": "เลือกสกุลเงิน"
  },
  "jghy": {
    "jghy": "อนาคต",
    "yxhy": "ถาวร",
    "mz": "ขาขึ้น",
    "md": "ขาลง",
    "gmj": "ราคาซื้อ",
    "jsj": "ราคาชำระ",
    "xj": "ราคาปัจจุบัน",
    "fx": "ทิศทาง",
    "sl": "ปริมาณ",
    "jgsj": "เวลาจัดส่ง",
    "gb": "ปิดตัวลง",
    "jxxd": "สั่งซื้อต่อ",
    "cclb": "รายชื่อตำแหน่ง",
    "zc": "ถืออยู่",
    "lscc": "ประวัติการถือ",
    "qblx": "ทุกประเภท",
    "yk": "กำไรขาดทุน",
    "ddqr": "ยืนยันการสั่งซื้อ",
    "dqsj": "วันที่ครบอายุ",
    "jssj": "เวลาตัดบัญชี",
    "sy": "รายได้",
    "tzje": "จำนวนเงินลงทุน",
    "zdje": "จำนวนเงินลงทุนมากกว่า 0",
    "kyye": "สมดุล: ",
    "kyye2": "สมดุล",
    "sxf": "ค่าธรรมเนียม: ",
    "sxfl": "ค่าธรรมเนียม",
    "jypz": "ประเภทการซื้อขาย",
    "jyfx": "ทิศทางการซื้อขาย",
    "qrxd": "ยืนยันสั่งซื้อ",
    "fs": "more",
    "dqye": "ยอดคงเหลือ"
  },
  "kjmb": {
    "title": "สกุลเงินดิจิตอล",
    "gm": "ซื้อ USDT",
    "wxts": "เคล็ดลับ:",
    "copy": "คัดลอก",
    "ljmb": "ซื้อสกุลเงินดิจิทัล",
    "qx": "ยกเลิก",
    "gmsl": "ปริมาณซื้อ",
    "cssl": "ปริมาณขาย",
    "qsrgmsl": "โปรดใส่จำนวนที่สั่งซื้อ",
    "qsrcssl": "โปรดใส่จำนวนที่ขาย",
    "jg": "ราคา",
    "fzcg": "คัดลอกสำเร็จ"
  },
  "tips": {
    "jymm": "รหัสผ่านการทำธุรกรรม",
    "szjymm": "ตั้งรหัสผ่านการทำธุรกรรม",
    "qsrjymm": "โปรดใส่รหัสผ่านการทำธุรกรรม",
    "jymmts": "โปรดไปที่ศูนย์ความปลอดภัยเพื่อตั้งรหัสผ่านการทำธุรกรรม"
  },
  "xyf":{
    "title": "คะแนนเครดิต",
    "pgsj": "เวลาประเมิน"
  },
  "dzrz":{
    "title": "การตรวจสอบที่อยู่",
    "sdddz":"ที่อยู่บิลค่าสาธารณูปโภค",
    "tpsc": "บิลอิมเมจอัพโหลด",
    "ts": "คำเตือน: คุณต้องกรอกข้อมูลที่อยู่และส่งบิลค่าสาธารณูปโภคหรือค่าที่อยู่บรอดแบนด์",
    "tips":"คุณต้องกรอกข้อมูลที่อยู่และส่งบิลค่าสาธารณูปโภคหรือค่าที่อยู่บรอดแบนด์",
    "qsczdtp":"บิลอิมเมจอัพโหลด"
  },
  "newReg":{
    "sjh": "โทรศัพท์มือถือ",
    "yx": "อีเมล",
    "yqm": "รหัสการเชิญ",
    "yqm2": "รหัสเชิญ (ไม่บังคับ)",
    "cjzh": "สร้างบัญชี",
    "sysjhzyx": "ลงทะเบียนด้วยเบอร์มือถือ/อีเมล",
    "sj": "มือถือ",
    "yhxy": "&lt;ข้อตกลงผู้ใช้&gt;",
    "yhxy2": "ฉันได้อ่านและยอมรับและ &lt;ข้อตกลงผู้ใช้&gt; "
  },
  "mbwt":{
    "title": "การตั้งค่าคำถามความปลอดภัยลับ",
    "mbwt": "คำถามเพื่อความปลอดภัย",
    "qtxda": "โปรดใส่คำตอบ",
    "qsrxmm": "กรุณาใส่รหัสผ่านใหม่",
    "sydqmmcz": "ใช้รหัสผ่านปัจจุบันในการรีเซ็ต",
    "zhmm": "ปัญหาด้านความปลอดภัย เรียกรหัสผ่าน",
    "ysz": "ตั้งค่าแล้ว",
    "tg": "ข้าม",
    "tj": "ส่ง",
    "zyts": "สำคัญ:",
    "zytsCont": "อย่าเปิดเผยคำตอบลับและรหัสยืนยัน และคำนึงถึงปัญหาด้านความปลอดภัยซึ่งจะช่วยให้คุณดึงรหัสผ่านของคุณ"
  },
  "xbsg":{
    "title": "ซนเหรียญใหม่",
    "wdsg": "รายละเอียด",
    "scts": "วันกักตัว: ",
    "sy": "ที่เหลืออยู่",
    "ljsg": "สมัครสมาชิกตอนนี้",
    "ysk": "ขายหมดแล้ว",
    "xzjdy": "สมัครสมาชิกตอนนี้",
    "dy": "ติดตาม",
    "fxjg": "ออกราคา",
    "fxl": "การไหลเวียน",
    "ssrq": "วันที่ลงรายการ",
    "yxqx": "ระยะเวลาที่ใช้ได้",
    "qsrsl": "กรุณาระบุจำนวนเงิน",
    "syl": "ที่เหลืออยู่",
    "sgrq": "ติดตาม",
    "sgsl": "จำนวน",
    "bz": "เหรียญ",
    "yebz": "ยอดเงิน USDT ไม่เพียงพอ",
    "tgsl": "ผ่านจำนวน",
    "shz": "ภายใต้การทบทวน",
    "wtg": "ไม่ผ่าน",
    "ytg": "ผ่านไป"
  },
  "wydb":{
    "title": "ยืม",
    "db": "ยืม",
    "dbz": "ยืม",
    "jl": "บันทึก",
    "jdzq": "ระยะเวลา (วัน)",
    "qhk": "เพื่อชำระคืน",
    "ljdb": "สะสม(usdt)",
    "dhkbs" :"ที่รอดำเนินการชำระเงิน",
    "jkje": "วงเงินกู้(usdt)",
    "qsrje": "กรุณาระบุจำนวนเงิน",
    "rll": "อัตราดอกเบี้ยรายวัน",
    "hkfs": "การชำระคืน",
    "dqych": "หมดอายุ",
    "lx": "ความสนใจ",
    "fkjg": "ผู้ให้กู้",
    "tpsc": "สินเชื่อเงินกู้ (อัพโหลดรูปภาพ)",
    "fwxx": "ข้อมูลที่อยู่อาศัย",
    "srzm": "หลักฐานแสดงรายได้ (ความสัมพันธ์ในการจ้างงาน)",
    "yhmx": "รายการเงินฝากถอนในบัญชีเงินฝาก",
    "zjz": "รูปถ่ายประจำตัว",
    "yd": "ฉันได้อ่านและตกลง",
    "xy": "สมัครสัญญาเงินกู้",
    "sqdb": "สมัครกลุ่มสินเชื่อ",
    "gb": "ปิด",
    "qd": "ตกลง",
    "ts": "โปรดตรวจสอบ สมัครสัญญาเงินกู้",
    "dbjl": "บันทึก",
    "hkhth": "รหัสการสั่งซื้อ",
    "wsh": "ยังไม่ได้ตรวจสอบ",
    "yfk": "เงินกู้",
    "sqrq": "เวลาสมัคร",
    "zq": "วงจร",
    "dbsl": "จำนวนซี่โครง",
    "zhke": "การชำระเงินทั้งหมด",
    "yhkxq": "รายละเอียดการชำระคืน",
    "bqyhk": "ชำระคืนในงวดปัจจุบัน(USDT)",
    "hktips": "กรุณาตรวจสอบให้แน่ใจว่ายอดเงินคงเหลือเพียงพอ หากยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วจึงค่อยชำระคืน",
    "bj": "อาจารย์ใหญ่",
    "jie": "ยืม",
    "ljhk": "ชำระคืนทันที",
    "qcz": "การฝาก",
    "yebzqxcz": "ยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วค่อยชำระคืน",
    "znj": "ค่าธรรมเนียมการชำระล่าช้า",
    "yqts": "วันที่เกินกำหนด"
  },
  "hkxq":{
    "dd":"คำสั่ง",
    "fzhkdz":"คัดลอกที่อยู่การชำระเงิน",
    "hkxq": "รายละเอียดการชำระคืน",
    "zlx": "ดอกเบี้ยทั้งหมด",
    "zhk": "ชำระคืนทั้งหมด",
    "hkjg": "หน่วยงานการชำระคืน",
    "hkpz": "ใบรับรองการชำระหนี้"
  },
  "bbjyNew":{
    "jylx": "ชนิดของ",
    "jyze": "จำนวน"
  },
  "indexNew":{
    "title": "เพิ่ม Spmaxex ไปที่อินเทอร์เฟซหลัก",
    "t1": "เข้าถึงประสบการณ์เต็มหน้าจออย่างรวดเร็ว",
    "t2": "คลิกที่แถบเครื่องมือด้านล่าง",
    "t3": "และเลือก",
    "t4": "พิ่มไปที่หน้าจอหลัก",
    "t5": "เพิ่มประสบการณ์ Spmaxex เวอร์ชันเต็มบนเดสก์ท็อป",
    "t6": "เพิ่มในรายการโปรด",
    "t7": "ค้นหาในเพจ"
  },
  "bind":{
    "title": "การตรวจสอบอีเมล",
    "ybd": "ผูกพัน",
    "wbd": "หลุด",
    "yrz": "ตรวจสอบแล้ว",
    "wrz": "ไม่ได้รับการยืนยัน",
    "ts": "เพื่อปกป้องบัญชีของคุณ ขอแนะนำให้ผูกที่อยู่อีเมล",
    "qsryxdz": "ที่อยู่อีเมล"
  },
  "status":{
    "statusText": ['ความล้มเหลว','รอดำเนินการ','ความสำเร็จ'],
 },
 "tipsNew":{
   "wjmmts": "กู้คืนรหัสผ่านด้วยรหัสยืนยัน",
   "qscpztp": "อัพโหลดภาพบัตรกำนัล",
   "emailgsts": "กรุณาใส่อีเมลที่ถูกต้อง",
   "telgsts": "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง",
   "lcmmbyz": "กรุณายืนยันรหัสผ่านของคุณ",
   "zdsl": "จำนวนขั้นต่ำ ",
   "sldydy": "ปริมาณที่มากกว่าหรือเท่ากับ",
   "zxtzsl": "จำนวนขั้นต่ำ ",
   "ddz": "ที่รอ",
   "xs": "ชั่วโมง",
   "min": "จำนวนขั้นต่ำ ",
   "max": "จำนวนสูงสุด ",
   "yebz": "ยอดเงินไม่เพียงพอ",
   "qsrss": "กรุณาใส่ล็อต",
   "zdss": "ล็อตขั้นต่ำ",
   "yjj": "ถูกปฏิเสธ",
   "shz": "การไถ่ถอน",
   "zwkfcz": "สกุลเงินนี้ยังไม่เปิดให้เติมเงิน",
   "jiaoge": "เดลิเวอรี่",
    "zhang": "ซื้อ",
    "die": "ขาย",
    "cjxnzh": "สร้างบัญชีเสมือน"
 },
 "langNew2":{
  "flzq": "ศูนย์กลางของรางวัล",
  "qdjl": "รางวัลเข้าสู่ระบบ",
  "mrqdjl": "รางวัลลงชื่อเข้าใช้รายวัน",
  "qd": "เข้าสู่ระบบ",
  "yqd": "ลงทะเบียนเข้า",
  "hdgz": "กฎของกิจกรรม",
  "qdjl2": "บันทึกการเช็คอิน",
  "qdcg": "ลงชื่อเข้าใช้สำเร็จ",
  "yhd": "ได้มา",
  "lq": "รับ",
  "dyt": "วันที่ 1",
  "det": "วันที่ 2",
  "dst": "วันที่ 3",
  "dsit": "วันที่ 4",
  "dwt": "วันที่ 5",
  "dlt": "วันที่ 6",
  "dqt": "วันที่ 7",
  "jxz": "กำลังดำเนินการ"
},
"langNew":{
  "kp": "เปิด",
  "zuoshou": "ได้รับเมื่อวาน",
  "zg": "สูงสุด",
  "zd": "ต่ำสุด",
  "dqjg": "ราคาปัจจุบัน",
  "pcjg": "ราคาปิด",
  "gd": "คำสั่งซื้อที่รอดำเนินการ",
  "gdj": "ราคาคำสั่งซื้อที่รอดำเนินการ",
  "gdjg": "ราคาคำสั่งซื้อที่รอดำเนินการ",
  "xfbzj": "เงินประกันที่จำเป็น: ",
  "ksrfw": "ช่วงอินพุตที่ใช้ได้: ",
  "shou": "จำนวนมาก",
  "fdjyk": "กำไรสุทธิลอยตัว",
  "pcsl": "ปริมาณการปิดบัญชี",
  "cx": "ถอน",
  "qrpc": "ยืนยันการปิดตำแหน่ง",
  "sx": "กรอง",
  "cz": "รีเซ็ต",
  "zdl": "รู้",
  "kccg": "เปิดตำแหน่งสำเร็จ!",
  "xzfx": "เลือกทิศทาง",
  "lx": "พิมพ",
  "xgcc": "แก้ไขตำแหน่ง",
  "szzyzs": "ตั้งค่าหยุดกำไรและหยุดการขาดทุน",
  "szhb": "สกุลเงินดิจิทัล",
  "gjs": "โลหะ",
  "yy": "น้ำมันดิบ",
  "jy": "ซื้อขาย",
  "jmhb": "สกุลเงินดิจิทัล",
  "gdsj": "เวลาการสั่งซื้อที่รอดำเนินการ",
  "gdsl": "จำนวนการสั่งซื้อที่รอดำเนินการ",
  "fs": "time"
 },
 "ieo":{
   "ieo": "ไออีโอ",
   "csjg": "ราคาเริ่มต้น",
   "syl": "ยอดคงเหลือ",
   "sjd": "คำสั่งซื้อของตลาด",
   "jj": "ราคาเฉลี่ย",
   "zsl": "จำนวนเงินทั้งหมด",
   "zyk": "กำไรและขาดทุนทั้งหมด",
   "ljmr": "ซื้อตอนนี้",
   "yqx": "ยกเลิก",
   "gmjl": "ประวัติการซื้อ",
   "yjs": "เกิน",
   "jzrq": "วันหมดอายุ",
   "xjcz": "เติมเงินเป็นเงินสด",
   "djlxkf": "หากคุณใช้เงินเยนญี่ปุ่นในการฝากเงิน กรุณาคลิกเพื่อติดต่อฝ่ายบริการลูกค้า",
   "qrrjts": "หากคุณใช้ USD ในการฝาก โปรดติดต่อฝ่ายบริการลูกค้า",
   "mmts": "อนุญาตให้ใช้เฉพาะตัวอักษรตัวพิมพ์ใหญ่และตัวพิมพ์เล็กบวกตัวเลขเท่านั้น"
  },
  "langNew4":{
    "qsrndzh": "กรุณากรอกหมายเลขบัญชีของคุณ",
    "ljcb": "ฝากเงินได้เลย",
    "ljtb": "ถอนเหรียญทันที",
    "flhd": "กิจกรรมสวัสดิการ",
    "flzx": "ศูนย์สวัสดิการ",
    "lqjl": "รับรางวัลสูงสุด",
    "wyzq": "ฉันได้รับ",
    "hdlb": "รายการกิจกรรม",
    "dk": "เงินกู้",
    "kyje": "จำนวนเงินที่มีอยู่",
    "je": "จำนวน",
    "zd": "ขีดสุด",
    "wxj": "อยากยืม...",
    "dkjl": "ประวัติสินเชื่อ",
    "xydk": "สินเชื่อสินเชื่อ",
    "tpsc": "อัพโหลดรูปภาพ",
    "dkts": "ไม่ต้องจ่ายดอกเบี้ยเป็นเวลา 3 วันหลังจากได้รับเงินกู้และจะจ่ายดอกเบี้ยหลังจากนั้น",
    "ljdk": "กู้ได้เลย",
    "qwc": "ทำให้สมบูรณ์"
  },
  share:{
    "hd": "รับรางวัลสกุลเงินดิจิทัล",
    "yqhy": "เชิญเพื่อนของคุณให้เข้าร่วมการวัดปริมาณ Ai เช่าเครื่องขุด และแลกเปลี่ยนผลิตภัณฑ์เพื่อรับรางวัลสกุลเงินดิจิทัล",
    "yqsy": "รายได้จากคำเชิญ",
    "yqrs": "จำนวนคนที่ได้รับเชิญ",
    "yqlj": "เชิญตามลิงค์ครับ",
    "lj": "ลิงค์",
    "yqm": "รหัสการเชิญ",
  },
  myAssets:{
    "cz": "เติม",
    "wzh": "ฝากสกุลเงินดิจิทัลหรือสกุลเงินตามกฎหมายเข้าบัญชีของคุณ",
    "tx": "ถอน",
    "xyzh": "ถอนสินทรัพย์จากบัญชีที่มีอยู่ไปยังบัตรธนาคารหรือกระเป๋าเงินของคุณ",
  },
  user:{
    "zcgl": "การจัดการสินทรัพย์",
    "xb": "สกุลเงินใหม่",
    "hd": "กิจกรรมและของรางวัล",
    "zhxg": "บัญชีที่เกี่ยวข้อง",
    "kf": "บริการลูกค้า",
    "sfrz": "การรับรองความถูกต้อง",
    "aq": "ความปลอดภัย",
    "gy": "เกี่ยวกับ",
    "sz": "ติดตั้ง",
    "gp": "คลังสินค้า",
    "wh": "ฟอเร็กซ์"
  },
  "langNew3":{
    "xw":"ข่าวสาร",
   "gdgnjxz":"ฟังก์ชั่นคัดลอกคำสั่งอยู่ระหว่างดำเนินการ",
   "gdts":"เริ่มคัดลอกคำสั่ง ผลตอบแทนสูง ผลตอบแทนสูง ให้คุณรับเหรียญได้โดยไม่ต้องออกแรง",
   "ksgd":"เริ่มคัดลอก",
   "gd":"ติดตาม",
   "gdlx1":"AI GPT",
   "gdlx2":"นักการเมือง",
   "gdlx3":"นักเทรด",
   "npjsy":"รายได้เฉลี่ยต่อปี",
   "gtrs":"จำนวนนักลงทุนติดตาม",
   "hbl":"อัตราผลตอบแทน",
   "gtje":"จำนวนเงินลงทุนติดตาม",
   "gt":"การลงทุนติดตาม",
   "gdz":"กำลังติดตาม",
   "ywc":"เสร็จสิ้น",
   "zdf":"ขึ้นและลง",
   "tz":"หยุด",
   "bdy":"ไม่น้อยกว่า",
   "xwxq":"รายละเอียดข่าว",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/th.js